import { $, addAction, INIT } from '@situation/setdesign.util';

const appendVideoIcon = () => {
    const polygon = '<polygon stroke-linejoin="round" stroke-width="10" points="10,10 70,40 10,70 " />';
    const svg = `<svg class="video-thumb__arrow" viewBox="0 0 80 80">${polygon}</svg>`;
    $('.external-video')
        .find('a')
        .append(`<span class="video-thumb__icon"><span class="video-thumb__circle">${svg}</span></span>`);
};

addAction(INIT, appendVideoIcon);
